import React, { FC } from "react";
import { Link } from "gatsby";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";
import { StyledLink } from "~/atoms/StyledLink";
import { PATH } from "~/constant/path";

type QuestionsType = {};

/*
 * アコーディオンの「＋」アイコン。
 * CSSのボックス（width/height）で線を描くと、ブラウザの拡大表示時に
 * 端数ピクセルの丸め方が項目ごとに変わり、線の太さがばらついてしまう。
 * 縦棒・横棒を同じ 16x16 のSVGとして描くことで、どの倍率でも太さが揃う。
 */
const markIcon = (rect: string) =>
  `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Crect ${rect} fill='${colors.defaultText.replace(
    "#",
    "%23"
  )}'/%3E%3C/svg%3E`;
const MARK_HORIZONTAL = markIcon("x='0' y='7' width='16' height='2'");
const MARK_VERTICAL = markIcon("x='7' y='0' width='2' height='16'");

export const Questions: FC<QuestionsType> = () => {
  return (
    <>
      <div id="questions" className="questionsSession" />
      <div className="container">
        <div className="titleWrapper">
          <span className="title">よくある質問</span>
        </div>
        <div className="qaWrapper">
          <details className="qa">
            <summary>Q. リファラル採用とは？</summary>
            <p>
              リファラル採用とは、既存の従業員が知人や友人を紹介して採用する手法です。
              従来の採用活動と比べて、紹介された候補者は企業文化への適応が早く、定着率も高い傾向があります。
              また、普段採用市場に出てきていない優秀な人材も獲得でき、従業員のエンゲージメント向上や、採用コストの削減にも効果的です。
              <br />
              <br />
              詳細はこちらをご覧ください。
              <br />
              <StyledLink to="/insight/referral/3362" target="_self">
                リファラル採用とは？意味やメリット・デメリット、促進方法と事例を解説
              </StyledLink>
            </p>
          </details>
          <details className="qa">
            <summary>Q. 料金体系はどのようになっていますか？</summary>
            <p>
              月額固定型と成果報酬型の料金体系からお選びいただけます。
              初年度はコンサルタントが深く入り込んだご支援によるサービス提供を行い、翌年以降はクラウドサービスのみのご利用も可能です。
              詳細の料金設計に関しましては、お問い合わせください。
              <br />
              <br />
              <Link
                to={PATH.INQUIRY_CONTACT.to}
                style={{ color: colors.orange, textDecoration: "underline" }}
              >
                お問い合わせはこちら
              </Link>
            </p>
          </details>
          <details className="qa">
            <summary>Q. 短期間の契約は可能ですか？</summary>
            <p>基本的には1年契約ですが、より短期間のご提案も可能です。</p>
          </details>
          <details className="qa">
            <summary>Q. どこまでリファラル採用の支援をしてくれるのですか？</summary>
            <p>
              社員様向けの説明会や資料準備、広報記事の作成、システムの運用など、あらゆる施策実施を対応しております。
            </p>
          </details>
          <details className="qa">
            <summary>Q. どれくらいの採用成果が見込めますか？</summary>
            <p> 初回商談時に、ヒアリングのちに成果シミュレーションをさせていただきます。</p>
          </details>
          <details className="qa">
            <summary>Q. 制作物のサポートはありますか？</summary>
            <p>はい、カードやポスターのグッズ作成や、オンラインにて配信可能な記事作成のサポートを行っております。</p>
          </details>
          <details className="qa">
            <summary>Q. クラウドサービス（Refcome）は使わずに、施策支援だけの依頼は可能ですか？</summary>
            <p>
              はい、可能です。
              クラウドサービスを使わない形で、社員の皆様が紹介しやすい動線設計を行うこともご支援しております。
            </p>
          </details>
          <details className="qa">
            <summary>Q. Refcomeのデモ環境は使えますか？</summary>
            <p>
              はい、可能です。
              デモ環境の発行前に、営業担当から、画面を映しながらどのようなことができるのかも、ご案内させていただいております。
            </p>
          </details>
        </div>
      </div>

      <style jsx>{`
        .questionsSession {
          content: "";
          display: block;
          height: 80px;
          margin-top: -80px;
          visibility: hidden;
        }
        .container {
          display: flex;
          justify-content: center;
          gap: 32px;
          margin: 0;
          padding: 48px 20px;
          background: ${colors.defaultBg};
        }
        .titleWrapper {
          width: 158px;
        }
        .title {
          font-size: 26px;
          font-weight: bold;
        }
        .qaWrapper {
          width: 810px;
        }
        .qa {
          width: 100%;
          margin-bottom: 7px;
          border-bottom: 2px solid ${colors.gray3};
        }
        .qa summary {
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          padding: 1em 2.5em 1em 1em;
          color: ${colors.defaultText};
          cursor: pointer;
          font-size: 18px;
        }
        .qa summary::-webkit-details-marker {
          display: none;
        }
        .qa summary::before,
        .qa summary::after {
          position: absolute;
          top: 50%;
          right: 18px;
          width: 16px;
          height: 16px;
          margin-top: -8px;
          background-repeat: no-repeat;
          background-position: center;
          background-size: 16px 16px;
          content: "";
        }
        .qa summary::before {
          background-image: url("${MARK_HORIZONTAL}");
        }
        .qa summary::after {
          background-image: url("${MARK_VERTICAL}");
          transition: rotate 0.3s;
        }
        .qa[open] summary {
          font-weight: bold;
        }
        .qa[open] summary::after {
          rotate: 90deg;
        }
        .qa p {
          transform: translateY(-10px);
          opacity: 0;
          margin: 0;
          padding: 0.1em 3.5em 1.5em;
          color: ${colors.defaultText};
          transition: transform 0.5s, opacity 0.5s;
          font-size: 18px;
          line-height: 1.85;
        }
        .qa[open] p {
          transform: none;
          opacity: 1;
        }
        @media (${breakPoints.tablet}) {
          .container {
            flex-direction: column;
            gap: 10px;
            padding: 48px 20px;
          }
          .titleWrapper {
            width: 100%;
          }
          .qaWrapper {
            width: 100%;
          }
          .qa {
            width: 100%;
          }
        }
        @media (${breakPoints.sp}) {
          .container {
            flex-direction: column;
            gap: 10px;
            padding: 48px 20px;
          }
          .titleWrapper {
            width: 100%;
          }
          .qaWrapper {
            width: 100%;
          }
          .qa {
            width: 100%;
          }
          .qa summary {
            padding: 1em 1.75em 1em 0;
            font-size: 16px;
          }
          .qa summary::before,
          .qa summary::after {
            right: 0;
          }
          .qa p {
            padding: 0.1em 1em 1em;
            font-size: 16px;
          }
        }
      `}</style>
    </>
  );
};
